import clienteAxios from "../config/axios";

export async function getAllProveedores() {
    return clienteAxios.get(`/proveedor`);
}

export async function getProveedoresFromSoftland() {
    return clienteAxios.get(`/proveedor/actualizarProveedores`);
}

export async function addProveedor(proveedor) {
    return clienteAxios.post(`/proveedor`,{proveedor:proveedor});
}

export async function updateProveedor(id,updates) {
    return clienteAxios.put(`/proveedor/${id}`,{updates});
}

export async function deleteProveedor(id) {
    return clienteAxios.delete(`/proveedor/${id}`,id);
}

export async function getProveedorFromInf(codfor, nrofor) {
    return clienteAxios.get(`/proveedor/getFromEntregaReal/codfor/${codfor}/nrofor/${nrofor}`);
}